import { FC } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

import { QueryParam } from '../../utils/constants'
import { CatalogType } from '../../utils/types/misc'

import styles from '../../styles/CatalogLayout.module.less'

interface CatalogItemCountProps {
  totalItemsAmount: number
  catalogType: CatalogType
  category?: string
}

const CatalogItemCount: FC<CatalogItemCountProps> = (props) => {
  const { category, totalItemsAmount, catalogType } = props

  const { t } = useTranslation('products')
  const { query } = useRouter()

  const searchQuery = query[QueryParam.search]
  const supplierPageQuery = query[QueryParam.supplierCode]

  if ((catalogType === 'products' && !category) && !searchQuery && !supplierPageQuery) {
    return null
  }

  let translatedItemText = ''
  if (catalogType === 'products') {
    translatedItemText = t('product', { count: totalItemsAmount })
  } else {
    // Plural translations available for supplier
    translatedItemText = t('supplier', { count: totalItemsAmount })
  }

  return (
    <div className={`${styles['products-count']} margin-bottom-spacer-double`}>
      {`${totalItemsAmount} ${translatedItemText}`}
    </div>
  )
}

export default CatalogItemCount
